import '../../../../../scss/user-modal.scss';

import { createApp } from 'vue';
//import Vue from 'vue';

import Router from 'vue-router';
import UserModal from './UserModal';
import { userModalRoute, userModalRouter } from './router';
import { getPiniaInstance } from '../../../store/page-store';
import { getValueFromCurrentUrl } from '../../../../qaamgo/helper/query-fragment-params';
import { testIsNotNull, testIsTrimmedStringNotEmpty } from '../../../../lib/test-and-assert/test-base';
import { testIsValidUserModalRoute } from './test';
import { useUserRegisterPaymentModalStore } from '../../../store/modules/user-register-payment-modal-store';

//Vue.use(Router);

/**
 * Parse mp parameter to extract route name and parameters
 * @param {string} mpValue - The mp parameter value (e.g., "contact-us-form/feature")
 * @returns {object} - { routeName: string, routeParam: string|null }
 */
function parseMpParameter(mpValue) {
    if (!mpValue) {
        return { routeName: null, routeParam: null };
    }

    const parts = mpValue.split('/');
    const routeName = parts[0];
    const routeParam = parts.length > 1 ? parts[1] : null;

    return { routeName, routeParam };
}

const userModalEl = document.createElement('div');
userModalEl.setAttribute('id', 'UserModal');

document.body.appendChild(userModalEl);

createApp(UserModal).use(getPiniaInstance()).use(userModalRouter).mount('#UserModal');

// TODO maybe switch to a different, more unique fragment key? remember to also change LoginView accordingly
const modalOpenFragment = getValueFromCurrentUrl('mp');

if (testIsNotNull(modalOpenFragment) && testIsTrimmedStringNotEmpty(modalOpenFragment)) {
    const { routeName, routeParam } = parseMpParameter(modalOpenFragment.trim());

    if (routeName && testIsValidUserModalRoute(routeName)) {
        const store = useUserRegisterPaymentModalStore();

        if (routeName === userModalRoute.LOGIN || routeName === userModalRoute.REGISTER) {
            store.setSkipPayment(true);
        }

        if (routeName === userModalRoute.CONTACT_US_FORM) {
            if (routeParam) {
                userModalRouter.push({
                    name: userModalRoute.CONTACT_US_FORM,
                    params: { defaultQuestionType: routeParam },
                });
            } else {
                userModalRouter.push({
                    name: userModalRoute.CONTACT_US_FORM,
                });
            }
            store.openOnPage(routeName);
        } else {
            // only open user modal on page load after the /me request is finished
            store.openOnPage(routeName);
        }
    }
}
